/**
 * Subscription Page - Paywall and Pricing
 * Subscription management and pricing plans
 */

import { storage, requireAuth } from '../utils/storage.js';
import { renderNavbar } from '../components/navbar.js';
import { renderFooter } from '../components/footer.js';
import { subscriptionApi } from '../services/api.js';

export function renderSubscription(container) {
  if (!requireAuth()) return;

  const subscription = storage.getSubscription();
  const trialDays = storage.getTrialDaysLeft();
  const isTrialing = subscription.status === 'trialing' && trialDays > 0;
  const isExpired = subscription.status === 'trialing' && trialDays <= 0;
  const isActive = subscription.status === 'active';

  container.innerHTML = `
    ${renderNavbar()}
    
    <main class="page" style="padding-top: 100px;">
      <div class="container">
        
        <!-- Header -->
        <div style="text-align: center; margin-bottom: 48px;">
          ${isExpired ? `
            <div class="alert alert-warning" style="max-width: 500px; margin: 0 auto 24px;">
              <i data-feather="alert-circle"></i>
              <div>
                <strong>Tu período de prueba ha terminado</strong>
                <p style="margin: 4px 0 0 0; font-size: 14px;">
                  Suscríbete para seguir accediendo a todas las funcionalidades.
                </p>
              </div>
            </div>
          ` : ''}
          
          <span class="section-badge">${isActive ? 'Tu suscripción' : 'Precios'}</span>
          <h1 style="margin-bottom: 12px;">
            ${isActive ? 'Gestiona tu suscripción' : 'Elige tu plan'}
          </h1>
          <p style="color: var(--gray-500); max-width: 500px; margin: 0 auto;">
            ${isTrialing
      ? `Te quedan <strong>${trialDays} días</strong> de prueba gratuita.`
      : isActive
        ? 'Tienes acceso completo a todas las funcionalidades.'
        : 'Accede a todas las herramientas para conseguir tu vivienda.'
    }
          </p>
        </div>
        
        ${isActive ? renderActiveSubscription(subscription) : renderPricingPlans(isTrialing, trialDays)}
        
        <!-- Features -->
        <div style="margin-top: 64px;">
          <h2 style="text-align: center; margin-bottom: 32px;">Todo lo que incluye HipotecaFácil</h2>
          
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 24px; max-width: 900px; margin: 0 auto;">
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="width: 32px; height: 32px; background: var(--primary-100); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                <i data-feather="book-open" style="width: 16px; height: 16px; color: var(--primary-600);"></i>
              </div>
              <div>
                <div style="font-weight: 600; margin-bottom: 4px;">Guía hipotecaria completa</div>
                <div style="font-size: 14px; color: var(--gray-500);">5 módulos con todo lo que necesitas saber</div>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="width: 32px; height: 32px; background: var(--primary-100); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                <i data-feather="sliders" style="width: 16px; height: 16px; color: var(--primary-600);"></i>
              </div>
              <div>
                <div style="font-weight: 600; margin-bottom: 4px;">Calculadoras financieras</div>
                <div style="font-size: 14px; color: var(--gray-500);">Ahorro, gastos, capacidad de compra</div>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="width: 32px; height: 32px; background: var(--primary-100); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                <i data-feather="gift" style="width: 16px; height: 16px; color: var(--primary-600);"></i>
              </div>
              <div>
                <div style="font-weight: 600; margin-bottom: 4px;">Ayudas públicas</div>
                <div style="font-size: 14px; color: var(--gray-500);">Estatales y autonómicas actualizadas</div>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="width: 32px; height: 32px; background: var(--primary-100); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                <i data-feather="target" style="width: 16px; height: 16px; color: var(--primary-600);"></i>
              </div>
              <div>
                <div style="font-weight: 600; margin-bottom: 4px;">Plan de ahorro personalizado</div>
                <div style="font-size: 14px; color: var(--gray-500);">Consejos según tu situación</div>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="width: 32px; height: 32px; background: var(--primary-100); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                <i data-feather="bar-chart-2" style="width: 16px; height: 16px; color: var(--primary-600);"></i>
              </div>
              <div>
                <div style="font-weight: 600; margin-bottom: 4px;">Dashboard personalizado</div>
                <div style="font-size: 14px; color: var(--gray-500);">Tu progreso en tiempo real</div>
              </div>
            </div>
            
            <div style="display: flex; align-items: flex-start; gap: 12px;">
              <div style="width: 32px; height: 32px; background: var(--primary-100); border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                <i data-feather="refresh-cw" style="width: 16px; height: 16px; color: var(--primary-600);"></i>
              </div>
              <div>
                <div style="font-weight: 600; margin-bottom: 4px;">Actualizaciones continuas</div>
                <div style="font-size: 14px; color: var(--gray-500);">Siempre al día con la normativa</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- FAQ -->
        <div style="margin-top: 64px; max-width: 700px; margin-left: auto; margin-right: auto;">
          <h2 style="text-align: center; margin-bottom: 32px;">Preguntas frecuentes</h2>
          
          <div style="display: flex; flex-direction: column; gap: 16px;">
            <details class="faq-item">
              <summary>¿Puedo cancelar en cualquier momento?</summary>
              <p>Sí, puedes cancelar tu suscripción cuando quieras. Seguirás teniendo acceso hasta el final del período de facturación actual.</p>
            </details>
            
            <details class="faq-item">
              <summary>¿Qué métodos de pago aceptáis?</summary>
              <p>Aceptamos tarjetas de crédito/débito (Visa, Mastercard) y PayPal a través de Stripe, nuestra plataforma de pagos segura.</p>
            </details>
            
            <details class="faq-item">
              <summary>¿Hay garantía de devolución?</summary>
              <p>Sí, ofrecemos 30 días de garantía. Si no estás satisfecho, te devolvemos el dinero sin preguntas.</p>
            </details>
            
            <details class="faq-item">
              <summary>¿La información está actualizada?</summary>
              <p>Actualizamos regularmente nuestra base de datos con los cambios en ayudas, normativa y tipos de interés. Aún así, siempre recomendamos verificar con fuentes oficiales.</p>
            </details>
          </div>
        </div>
        
        <!-- Legal -->
        <div style="margin-top: 48px; text-align: center;">
          <p style="font-size: 12px; color: var(--gray-400); max-width: 600px; margin: 0 auto;">
            Los pagos se procesan de forma segura a través de Stripe. Al suscribirte aceptas nuestros 
            <a href="#" style="color: var(--primary-600);">Términos de Servicio</a> y 
            <a href="#" style="color: var(--primary-600);">Política de Privacidad</a>.
            Este servicio no constituye asesoramiento financiero profesional.
          </p>
        </div>
        
      </div>
    </main>
    
    ${renderFooter()}
    
    <style>
      .faq-item {
        background: white;
        border-radius: var(--radius-lg);
        border: 1px solid var(--gray-200);
        overflow: hidden;
      }
      
      .faq-item summary {
        padding: 16px 20px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      
      .faq-item summary::-webkit-details-marker {
        display: none;
      }
      
      .faq-item summary::after {
        content: '+';
        font-size: 20px;
        color: var(--gray-400);
        transition: var(--transition-fast);
      }
      
      .faq-item[open] summary::after {
        transform: rotate(45deg);
      }
      
      .faq-item p {
        padding: 0 20px 16px;
        margin: 0;
        color: var(--gray-600);
        line-height: 1.7;
      }
    </style>
  `;

  initSubscriptionButtons();
}

function renderPricingPlans(isTrialing, trialDays) {
  return `
    <div class="pricing-grid">
      <!-- Monthly -->
      <div class="card pricing-card">
        <div class="pricing-name">Mensual</div>
        <div class="pricing-price">9,99€<span>/mes</span></div>
        <p class="pricing-description">
          Flexibilidad total, cancela cuando quieras
        </p>
        
        <ul class="pricing-features">
          <li>Acceso completo a la plataforma</li>
          <li>Guía hipotecaria de 5 módulos</li>
          <li>Calculadoras financieras</li>
          <li>Ayudas públicas actualizadas</li>
          <li>Plan de ahorro personalizado</li>
          <li>Soporte por email</li>
        </ul>
        
        <button class="btn btn-secondary w-full subscribe-btn" data-plan="monthly">
          ${isTrialing ? 'Suscribirse' : 'Empezar ahora'}
        </button>
      </div>
      
      <!-- Annual -->
      <div class="card pricing-card featured">
        <div class="pricing-name">Anual</div>
        <div class="pricing-price">79,99€<span>/año</span></div>
        <p class="pricing-description">
          <span style="color: var(--success); font-weight: 600;">Ahorra 40€</span> (6,66€/mes)
        </p>
        
        <ul class="pricing-features">
          <li>Todo lo del plan mensual</li>
          <li>2 meses gratis</li>
          <li>Acceso prioritario a nuevas funciones</li>
          <li>Checklist descargable en PDF</li>
          <li>Soporte prioritario</li>
          <li>Garantía de 30 días</li>
        </ul>
        
        <button class="btn btn-primary w-full subscribe-btn" data-plan="annual">
          ${isTrialing ? 'Suscribirse' : 'Empezar ahora'}
        </button>
      </div>
    </div>
    
    ${isTrialing ? `
      <p style="text-align: center; margin-top: 24px; color: var(--gray-500);">
        No te cobraremos hasta que termine tu período de prueba (${trialDays} días restantes)
      </p>
    ` : ''}
  `;
}

function renderActiveSubscription(subscription) {
  return `
    <div class="card" style="max-width: 500px; margin: 0 auto;">
      <div style="text-align: center; margin-bottom: 24px;">
        <div style="width: 64px; height: 64px; background: rgba(16, 185, 129, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;">
          <i data-feather="check-circle" style="color: var(--success); width: 32px; height: 32px;"></i>
        </div>
        <h3 style="margin-bottom: 8px;">Suscripción activa</h3>
        <span class="badge badge-success">Plan ${subscription.plan || 'Premium'}</span>
      </div>
      
      <div style="border-top: 1px solid var(--gray-100); padding-top: 20px;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
          <span style="color: var(--gray-500);">Estado</span>
          <span style="font-weight: 600; color: var(--success);">Activa</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
          <span style="color: var(--gray-500);">Próxima facturación</span>
          <span style="font-weight: 600;">${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('es-ES')}</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span style="color: var(--gray-500);">Precio</span>
          <span style="font-weight: 600;">9,99€/mes</span>
        </div>
      </div>
      
      <div style="margin-top: 24px; display: flex; gap: 12px;">
        <button class="btn btn-ghost flex-1">Cambiar plan</button>
        <button class="btn btn-ghost flex-1" style="color: var(--error);">Cancelar</button>
      </div>
    </div>
  `;
}

function initSubscriptionButtons() {
  const buttons = document.querySelectorAll('.subscribe-btn');

  buttons.forEach(btn => {
    btn.addEventListener('click', async () => {
      const plan = btn.dataset.plan;

      // Show loading state
      const originalContent = btn.innerHTML;
      btn.innerHTML = '<div class="spinner" style="width: 20px; height: 20px; border-width: 2px;"></div>';
      btn.disabled = true;

      try {
        // Call backend to create Stripe checkout session
        const response = await subscriptionApi.createCheckout(plan);

        if (response.url) {
          // Redirect to Stripe Checkout
          window.location.href = response.url;
        } else {
          throw new Error('No checkout URL received');
        }
      } catch (error) {
        console.error('Checkout error:', error);

        // Show error and restore button
        btn.innerHTML = originalContent;
        btn.disabled = false;

        alert(`❌ Error al procesar el pago: ${error.message || 'Inténtalo de nuevo más tarde.'}`);
      }
    });
  });
}
